import React, { useEffect } from 'react';
import './GoogleReviewsWidget.css';

const GoogleReviewsWidget = () => {
  useEffect(() => {
    // Load Elfsight script if not already loaded
    if (!document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://elfsightcdn.com/platform.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  return (
    <section className="google-reviews-section">
      <div className="reviews-container">
        <div className="reviews-header">
          <h2 className="reviews-title">What Our Guests Say</h2>
          <p className="reviews-subtitle">Real reviews from Google Maps</p>
        </div>
        
        {/* Elfsight Google Reviews Widget */}
        <div className="elfsight-app-a49e150e-0419-4c63-89b4-aced788be5af" data-elfsight-app-lazy></div>
      </div>
    </section>
  );
};

export default GoogleReviewsWidget;
